import { createElement, forwardRef, type Ref } from 'react';
import { Form } from 'semantic-ui-react';

// React 19 removed defaultProps support for function components.
// semantic-ui-react 2.x uses defaultProps to supply the `control` prop on Form.*
// shorthand components (Form.Input, Form.Select, etc.). Without it, Form.Field
// receives control=undefined and renders only the label — no input element.
//
// The defaultProps objects still exist on each component; React 19 just no longer
// reads them. This polyfill wraps each Form.* shorthand to apply its own defaults
// manually, restoring the expected behavior without modifying any call sites.

const shorthandNames = [
  'Input',
  'Select',
  'TextArea',
  'Checkbox',
  'Radio',
  'Button',
  'Dropdown'
] as const;

shorthandNames.forEach((name) => {
  const Component = (Form as any)[name];
  if (!Component || !Component.defaultProps) return;

  const defaults = Component.defaultProps;
  const Original = Component;

  const Patched = forwardRef(function Patched(props: object, ref: Ref<unknown>) {
    return createElement(Original, { ...defaults, ...props, ref });
  });
  Patched.displayName = Original.displayName;

  // Preserve static properties (handledProps, etc.)
  Object.keys(Original).forEach((key) => {
    (Patched as any)[key] = Original[key];
  });

  (Form as any)[name] = Patched;
});
